export const de = {
  "countryList": {
    "ISO_3166_704": "Vietnam",
    "ISO_3166_156": "China",
    "ISO_3166_344": "Hongkong (China)",
    "ISO_3166_158": "Taiwan (China)",
    "ISO_3166_446": "Macau (China)",
    "ISO_3166_004": "Afghanistan",
    "ISO_3166_008": "Albanien",
    "ISO_3166_020": "Andorra",
    "ISO_3166_024": "Angola",
    "ISO_3166_010": "Antarktis",
    "ISO_3166_028": "Antigua und Barbuda",
    "ISO_3166_032": "Argentinien",
    "ISO_3166_051": "Armenien",
    "ISO_3166_533": "Aruba",
    "ISO_3166_036": "Australien",
    "ISO_3166_040": "Österreich",
    "ISO_3166_031": "Aserbaidschan",
    "ISO_3166_784": "Vereinigte Arabische Emirate",
    "ISO_3166_044": "Bahamas",
    "ISO_3166_048": "Bahrain",
    "ISO_3166_050": "Bangladesch",
    "ISO_3166_052": "Barbados",
    "ISO_3166_112": "Weißrussland",
    "ISO_3166_084": "Belize",
    "ISO_3166_056": "Belgien",
    "ISO_3166_204": "Benin",
    "ISO_3166_060": "Bermuda-Inseln",
    "ISO_3166_064": "Bhutan",
    "ISO_3166_068": "Bolivien",
    "ISO_3166_070": "Bosnien und Herzegowina",
    "ISO_3166_072": "Botswana",
    "ISO_3166_076": "Brasilien",
    "ISO_3166_096": "Brunei",
    "ISO_3166_100": "Bulgarien",
    "ISO_3166_854": "Burkina Faso",
    "ISO_3166_108": "Burundi",
    "ISO_3166_120": "Kamerun",
    "ISO_3166_124": "Kanada",
    "ISO_3166_140": "Zentralafrikanische Republik",
    "ISO_3166_152": "Chile",
    "ISO_3166_162": "Weihnachtsinsel",
    "ISO_3166_166": "Kokosinseln",
    "ISO_3166_170": "Kolumbien",
    "ISO_3166_756": "Schweiz",
    "ISO_3166_178": "Kongo",
    "ISO_3166_184": "Cook-Insel",
    "ISO_3166_188": "Costa Rica",
    "ISO_3166_384": "Elfenbeinküste",
    "ISO_3166_192": "Kuba",
    "ISO_3166_196": "Zypern",
    "ISO_3166_203": "Tschechische Republik",
    "ISO_3166_208": "Dänemark",
    "ISO_3166_262": "Dschibuti",
    "ISO_3166_276": "Deutschland",
    "ISO_3166_214": "Dominikanische Republik",
    "ISO_3166_012": "Algerien",
    "ISO_3166_218": "Ecuador",
    "ISO_3166_818": "Ägypten",
    "ISO_3166_732": "Westsahara",
    "ISO_3166_724": "Spanien",
    "ISO_3166_233": "Estland",
    "ISO_3166_231": "Äthiopien",
    "ISO_3166_242": "Fidschi",
    "ISO_3166_238": "Falklandinseln",
    "ISO_3166_246": "Finnland",
    "ISO_3166_250": "Frankreich",
    "ISO_3166_583": "Mikronesien",
    "ISO_3166_266": "Gabun",
    "ISO_3166_226": "Äquatorial-Guinea",
    "ISO_3166_254": "Französisch Guyana",
    "ISO_3166_270": "Gambia",
    "ISO_3166_239": "Georgien",
    "ISO_3166_288": "Ghana",
    "ISO_3166_292": "Gibraltar",
    "ISO_3166_300": "Griechenland",
    "ISO_3166_304": "Grönland",
    "ISO_3166_826": "Vereinigtes Königreich",
    "ISO_3166_308": "Grenada",
    "ISO_3166_312": "Guadeloupe",
    "ISO_3166_316": "Guam",
    "ISO_3166_320": "Guatemala",
    "ISO_3166_324": "Guinea",
    "ISO_3166_624": "Guinea Bissau",
    "ISO_3166_328": "Guyana",
    "ISO_3166_191": "Kroatien",
    "ISO_3166_332": "Haiti",
    "ISO_3166_340": "Honduras",
    "ISO_3166_348": "Ungarn",
    "ISO_3166_352": "Island",
    "ISO_3166_356": "Indien",
    "ISO_3166_360": "Indonesien",
    "ISO_3166_364": "Iran",
    "ISO_3166_368": "Irak",
    "ISO_3166_086": "Britisches Territorium im Indischen Ozean",
    "ISO_3166_372": "Irland",
    "ISO_3166_376": "Israel",
    "ISO_3166_380": "Italien",
    "ISO_3166_388": "Jamaika",
    "ISO_3166_392": "Japan",
    "ISO_3166_400": "Jordanien",
    "ISO_3166_398": "Kasachstan.",
    "ISO_3166_404": "Kenia",
    "ISO_3166_296": "Kiribas",
    "ISO_3166_408": "Nordkorea",
    "ISO_3166_410": "Korea",
    "ISO_3166_116": "Kambodscha",
    "ISO_3166_174": "Komoren",
    "ISO_3166_414": "Kuwait",
    "ISO_3166_417": "Kirgisistan",
    "ISO_3166_136": "Cayman-Inseln",
    "ISO_3166_418": "Auf Lager",
    "ISO_3166_144": "Sri Lanka",
    "ISO_3166_428": "Lettland",
    "ISO_3166_422": "Libanon",
    "ISO_3166_426": "Lesotho",
    "ISO_3166_430": "Liberia",
    "ISO_3166_434": "Libyen",
    "ISO_3166_438": "Liechtenstein",
    "ISO_3166_440": "Litauen",
    "ISO_3166_442": "Luxemburg",
    "ISO_3166_450": "Madagaskar",
    "ISO_3166_454": "Malawi",
    "ISO_3166_458": "Malaysia",
    "ISO_3166_462": "Malediven",
    "ISO_3166_466": "Mali",
    "ISO_3166_470": "Malta",
    "ISO_3166_584": "Marshallinseln",
    "ISO_3166_478": "Mauretanien",
    "ISO_3166_480": "Mauretanien",
    "ISO_3166_484": "Mexiko",
    "ISO_3166_498": "Moldawien",
    "ISO_3166_492": "Monaco",
    "ISO_3166_496": "Mongolei",
    "ISO_3166_504": "Marokko",
    "ISO_3166_508": "Mosambik",
    "ISO_3166_104": "Myanmar",
    "ISO_3166_516": "Namibia",
    "ISO_3166_520": "Nauru",
    "ISO_3166_524": "Nepal",
    "ISO_3166_528": "Niederlande",
    "ISO_3166_540": "Neukaledonien",
    "ISO_3166_554": "Neuseeland",
    "ISO_3166_558": "Nicaragua",
    "ISO_3166_562": "Niger",
    "ISO_3166_566": "Nigeria",
    "ISO_3166_570": "Niue Insel",
    "ISO_3166_578": "Norwegen",
    "ISO_3166_512": "Oman",
    "ISO_3166_586": "Pakistan",
    "ISO_3166_260": "Französisch Polynesien",
    "ISO_3166_585": "Palau",
    "ISO_3166_591": "Panama",
    "ISO_3166_598": "Papua-Neuguinea",
    "ISO_3166_600": "Paraguay",
    "ISO_3166_604": "Peru",
    "ISO_3166_608": "Philippinen",
    "ISO_3166_612": "Pitcairn-Inseln",
    "ISO_3166_616": "Polen",
    "ISO_3166_620": "Portugal",
    "ISO_3166_630": "Puerto Rico",
    "ISO_3166_634": "Katar",
    "ISO_3166_642": "Rumänien",
    "ISO_3166_643": "Russland",
    "ISO_3166_646": "Ruanda",
    "ISO_3166_222": "El Salvador",
    "ISO_3166_654": "St. Helena",
    "ISO_3166_674": "San Marino",
    "ISO_3166_678": "Sao Tome und Principe",
    "ISO_3166_682": "Saudi-Arabien",
    "ISO_3166_686": "Senegal",
    "ISO_3166_690": "Seychellen",
    "ISO_3166_694": "Sierra Leone",
    "ISO_3166_702": "Singapur",
    "ISO_3166_703": "Slowakei",
    "ISO_3166_705": "Slowenien",
    "ISO_3166_090": "Salomonen",
    "ISO_3166_706": "Somalia",
    "ISO_3166_736": "Sudan",
    "ISO_3166_740": "Surinam",
    "ISO_3166_748": "Swasiland",
    "ISO_3166_752": "Schweden",
    "ISO_3166_760": "Syrien",
    "ISO_3166_810": "Sowjetunion",
    "ISO_3166_148": "Tschad",
    "ISO_3166_762": "Tadschikistan",
    "ISO_3166_834": "Tansania",
    "ISO_3166_764": "Thailand",
    "ISO_3166_768": "Togo",
    "ISO_3166_772": "Tokla",
    "ISO_3166_776": "Tonga",
    "ISO_3166_780": "Trinidad und Tobago",
    "ISO_3166_788": "Tunesien",
    "ISO_3166_792": "Türkei",
    "ISO_3166_626": "Osttimor",
    "ISO_3166_795": "Turkmenistan",
    "ISO_3166_798": "Tuvalu",
    "ISO_3166_800": "Uganda",
    "ISO_3166_804": "Ukraine",
    "ISO_3166_840": "Vereinigte Staaten",
    "ISO_3166_858": "Uruguay",
    "ISO_3166_860": "Usbekistan",
    "ISO_3166_336": "Vatikan",
    "ISO_3166_862": "Venezuela",
    "ISO_3166_882": "Westsamoa",
    "ISO_3166_887": "Jemen",
    "ISO_3166_891": "Jugoslawien",
    "ISO_3166_710": "Südafrika",
    "ISO_3166_180": "Zaire",
    "ISO_3166_894": "Sambia",
    "ISO_3166_716": "Simbabwe",
    "ISO_3166_074": "Boway-Insel",
    "ISO_3166_662": "St. Lucia",
    "ISO_3166_666": "St. Pierre und Miquelon",
    "ISO_3166_659": "St. Kitts und Nevis",
    "ISO_3166_670": "St. Vincent und die Grenadinen",
    "ISO_3166_581": "Vereinigte Staaten Minor Outlying Islands",
    "ISO_3166_548": "Vanuatu",
    "ISO_3166_580": "Nördliche Marianen",
    "ISO_3166_831": "Guernsey",
    "ISO_3166_175": "Mayotte",
    "ISO_3166_876": "Wallis und Futuna",
    "ISO_3166_850": "Jungferninseln, U.S.",
    "ISO_3166_796": "Turks- und Caicosinseln",
    "ISO_3166_728": "Südsudan",
    "ISO_3166_744": "Svalbard und Jan Mayen",
    "ISO_3166_729": "Sudan",
    "ISO_3166_688": "Serbien",
    "ISO_3166_638": "Réunion",
    "ISO_3166_275": "Palästina, Staat",
    "ISO_3166_574": "Norfolkinsel",
    "ISO_3166_500": "Montserrat",
    "ISO_3166_474": "Martinique",
    "ISO_3166_663": "Saint Martin (französischer Teil)",
    "ISO_3166_499": "Montenegro",
    "ISO_3166_832": "Jersey",
    "ISO_3166_833": "Isle of Man",
    "ISO_3166_334": "Heard Island und McDonald-Inseln",
    "ISO_3166_268": "Georgien",
    "ISO_3166_234": "Färöer Inseln",
    "ISO_3166_258": "Französisch Polynesien",
    "ISO_3166_232": "Eritrea",
    "ISO_3166_212": "Dominica",
    "ISO_3166_132": "Kap Verde",
    "ISO_3166_092": "Jungferninseln, Britisch",
    "ISO_3166_016": "Amerikanisch-Samoa",
    "ISO_3166_535": "Bonaire, Sint Eustatius und Saba",
    "ISO_3166_652": "St. Barthélemy",
    "ISO_3166_248": "Åland-Inseln",
    "ISO_3166_660": "Anguilla",
    "ISO_3166_807": "Mazedonien"
  },
  "login": {
    "App Store 下载": "App Store",
    "Google Play 下载": "Google Play",
    "注册": "Jetzt registrieren",
    "title": "Buy Crypto with <br/>Visa/Master Credit Card!",
    "title2": "14000USDT",
    "title3": "Exclusive for New Users",
    "li1": "Founded in 2011, BTCC is the world's longest-running <br/> crypto exchange",
    "li1_1": "Founded in 2011, BTCC is the world's longest-running crypto exchange",
    "li2": "US MSB and CA MSB licensed",
    "li3": "18+ cryptocurrencies available ",
    "li4": "Allows for deposits in 9+ fiat currencies",
    "li5": "Trade with 1 - 150 leverage ",
    "li6": "Meet the deposit targets within 7 days after successful registration at BTCC, and you can enjoy the bonus of the corresponding target levels.",
    "tab1": "Email Registration ",
    "email": "Bitte Ihre Email-Adresse eingeben",
    "code": "Please enter your verification code",
    "Send": "Get verification code",
    "pwd": "Bitte geben Sie Ihr Passwort ein",
    "tab2": "Mobile Registration ",
    "mobile": "Bitte Ihre Handynummer eingeben",
    "Register": "Jetzt registrieren",
    "服务条款": "https://www.btcc.com/en-US/detail/142641",
    "隐私声明": "https://www.btcc.com/en-US/detail/142638",
    "风险提示": "https://www.btcc.com/en-US/detail/149036",
    "and": "and",
    "首页url": "https://lp.btcc.academy/en-GB",
    "首页": "Home",
    "关于我们": "About Us",
    "about": "https://www.btcc.com/en-US/about-btcc",
    "about_in": "https://www.btcc.com/en-US/about-btcc",
    "about_dm": "https://www.btcc.com/en-US/about-btcc",
    "about_dms": "https://www.btcc.com/en-US/about-btcc",
    "about_coupon": "https://www.btcc.com/en-US/about-btcc",
    "about_rebate": "https://www.btcc.com/en-US/about-btcc",
    "about_lottery": "https://www.btcc.com/en-US/about-btcc",
    "mobileTip": "Das Feld Handynummer darf nicht leer sein",
    "emailTip": "Bitte Ihre Email-Adresse eingeben",
    "codeTip": "Please enter a valid verification code",
    "pwdTip": "Das Passwort muss 8-16 Zeichen lang sein und sowohl Groß- und Kleinbuchstaben als auch Zahlen und Sonderzeichen enthalten.",
    "tips": "I have read and agree to BTCC's",
    "tips1": "《User agreement》",
    "tips2": "《Privacy policy》",
    "tips3": "《Risk Disclosure》",
    "registeSuccessInfo": "Thank you for your registration. ",
    "startTrading": "Start trading now!",
    "registeSuccessInfoPhone": "Thank you for your registration. ",
    "startTradingPhone": "Start trading now!"
  },
  "RegisterThirdParty": {
    "验证码": "Bestätigungscode",
    "从注册开始": "Konto erstellen",
    "邮箱注册": "Email",
    "输入电子邮箱": "Bitte Ihre Email-Adresse eingeben",
    "设置登录密码": "Set up a password",
    "手机注册": "Mobil",
    "手机号": "Mobil",
    "邮箱": "Email",
    "密码": "Password",
    "邀请码": "Referral code (optional)",
    "下一步": "Nächste",
    "协议": "As you proceed to complete your registration, you agree to our User Agreement,Privacy Policy and Risk Disclosure We will never divulge any of your personal information without your prior consent.",
    "綁定電子信箱": "Bind your email address"
  },
  "banner_title": "Traden Sie mit einem vertrauensvollen wechseln",
  "banner_des": "Belohnungen ganz einfach erhalten",
  "tab1_title": "$309.94 Milliarde",
  "tab1_des": "24-Stunden-Handelsvolumen",
  "tab2_title": "$257.12 Milliarde",
  "tab2_des": "24-Stunden Open Interest",
  "tab3_title": "9.10 Million",
  "tab3_des": "Registrierte Benutzer",
  "tab4_title": "14 Jahre",
  "tab4_des": "Sichere Betriebshistorie",
  "sign_up": "Registrieren",
  "try_demo": "Probieren Sie das Demokonto aus",
  "why_choose_btcc": "Warum BTCC?",
  "reason1_title": "Weltweit führende Kryptobörse",
  "reason1_des": "BTCC wurde 2011 gegründet und verzeichnete 0 Sicherheitsvorfälle",
  "reason2_title": "Schnelle Kontoeröffnung",
  "reason2_des": "Die Kontoeröffnung bei uns ist schnell und einfach – Sie könnten noch heute handeln.",
  "reason3_title": "Schnelle Ein- und Auszahlungen",
  "reason3_des": "Zahlen Sie Fiat-Währungen mit hoher Transaktionsgeschwindigkeit in Krypto-Assets ein",
  "reason4_title": "24/7 Kundensupport",
  "reason4_des": "Haben Sie Fragen zu Ihrem Konto oder zum Trading? Unser freundliches Support-Team hilft Ihnen gerne – per Telefon, E-Mail, WhatsApp oder Live-Chat.",
  "reason5_title": "Einstellbarer Hebel",
  "reason5_des": "Handeln Sie mit BTC/ETH/SOL/XRP und mehr und wählen Sie den für Sie passenden Hebel von 1x bis 500x.",
  "reason6_title": "Nutzerfreundliche Demo",
  "reason6_des": "Bauen Sie Ihre Trading-Erfahrung ganz einfach und ohne Risiko auf.",
  "reviews_section_title": "Lesen Sie die Bewertungen – erfahren Sie mehr über uns",
  "reviews1": "Every time I've needed help with deposit or transfer, BTCC's team has been friendly and very knowledgeable.",
  "reviews2": "The overall experience on BTCC has been positive for me. Everything works as advertised.",
  "reviews3": "Great mobile interface",
  "reviews4": "This crypto platform is really great..you can share buy sell or trade for extra cash on top of whatever you choose fit.",
  "reviews5": "When I first downloaded the app I have my doubts but they were proven wrong and I found that the app is very user-friendly. The system for making transactions and deposits was very seamless and smooth no delays in any transactions",
  "reviews6": "BTCC is the first exchange I knew when I started trading with cryptocurrencies, is a very secure and reliable platform",
  "reviews7": "I'm fairly new to crypto, but the BTCC app has made learning easy.",
  "reviews8": "I absolutely love this app! It has been a game-changer for me in so many ways. The user interface is incredibly intuitive and user-friendly, making it easy for me to navigate and utilize all of its features.",
  "reviews9": "BTCC's mobile app had a glitch for me once; I pinged support and they fixed it within minutes. Great after-service.",
  "reviews10": "It is one of the very first digital coin trading apps I ever downloaded, it helped me understand alot of things that were new to me in this ever so fast growing digital currency world.",
  "reviews11": "The app works great and is a go to bitcoin app among all the many ,less than stellar, bitcoin apps out there. I really suggest using this one first",
  "reviews12": "Being new to trading and investing, this app has been a great help for the most part. Being able to learn the basics of trading and investing through the provided lessons is a good touch.",
  "our_markets": "Unsere Märkte",
  "step_title": "Sind Sie bereit, mit dem Krypto-Handel zu beginnen?",
  "step_subtitle": "Handel auf einer Plattform, der Millionen Menschen vertrauen",
  "step1": "1. Erstellen Sie Ihr Konto",
  "step2": "2. Tätigen Sie Ihre erste Einzahlung",
  "step3": "3. Beginnen Sie mit dem Trading",
  "bottom_card_title": "Fordern Sie Ihren 10%-Bonus auf Ihre erste Einzahlung an",
  "bottom_card_text1": "1. Mindesteinzahlung: 500 USDT",
  "bottom_card_text2": "2. Maximaler Bonus: 10.000 $",
  "bottom_card_text3": "3. Der Bonus wird berechtigten Nutzern einmal pro Woche gutgeschrieben.",
  "rules": "Risikowarnung: Der Handel mit digitalen Vermögenswerten ist eine aufstrebende Branche mit vielversprechender Zukunft, birgt aber als neues Phänomen auch erhebliche Risiken. Dies gilt insbesondere für den Leverage-Handel, bei dem der Hebel sowohl potenzielle Gewinne als auch Risiken verstärkt. Bitte stellen Sie sicher, dass Sie die Branche, die Mechanismen des Leverage-Handels und die damit verbundenen Regeln vollständig verstehen, bevor Sie teilnehmen. Wir empfehlen dringend, nur im Rahmen des Risikos zu handeln, das Sie persönlich tragen können. Handel birgt Risiken – seien Sie daher vorsichtig!",
  "stay_with_BTCC": "Mit BTCC immer einen Schritt voraus, immer sicher",
  "leverage": "Leverage",
  "all_crypto": "Kryptowährungen",
  "max_fee": "Max. Gebühr",
  "min_fee": "Min. Gebühr",
  "upgrade_vip": "Upgraden Sie auf VIP für fantastische Privilegien!",
  "invite_friend_make": "Freunde einladen und <span>{{amount}} USDT</span> verdienen",
  "invite_friend_commission": "Genießen Sie Provisionen von bis zu <span>35%</span>",
  "usdt_futures": "USDT-M Perpetual Futures",
  "coin_margined_futures": "Coin-M Perpetual Futures",
  "spot": "Spot",
  "all": "All",
  "mainstream": "Top",
  "meme": "Meme",
  "sol_eco": "SOL-Ökosystem",
  "btc_eco": "BTC-Ökosystem",
  "bot_ai": "Bot & AI",
  "web3_metaverse": "Web3 & Metaverse",
  "ly1_ly2": "Layer1/2",
  "defi": "DeFi",
  "marketplace": "Marktplatz",
  "infrastructure": "Infrastruktur",
  "innov_dist": "Inno",
  "forex": "Forex",
  "tokenized_stocks_commodities": "Tokenisierte Aktien & Rohstoffe",
  "name": "Name",
  "price": "Preis",
  "24h_change": "24h-Veränderung",
  "24h_highest_price": "Höchster 24h-Preis",
  "24h_lowest_price": "Niedrigster 24h-Preis",
  "24h_trading_volume": "24h-Handelsvolumen",
  "market_trade": "Handel",
  "contract_search": "Coins/Handelspaare suchen",
  "sorry_title": "Sorry, die Seite, die Sie suchen, konnte nicht aufgerufen werden",
  "sorry_tips": "Kehren Sie zur Startseite zurück, um andere Inhalte zu sehen",
  "goback": "Zurück",
  "发送验证码成功": "Der Bestätigungscode wurde erfolgreich gesendet! Falls kein Bestätigungscode eingeht, überprüfen Sie bitte Ihren Spam-/Junk-Ordner.",
  "trade_now": "Jetzt handeln"
}
